var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayStore = function SvgPlayStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 35,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FD3",
    d: "M23.35 22.52c4.005-2.238 7.067-3.943 7.33-4.076.837-.453 1.7-1.653 0-2.585-.55-.293-3.509-1.946-7.33-4.078l-5.262 5.384z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F66",
    d: "M18.088 17.165 1.283 34.406c.392.053.837-.053 1.36-.346 1.1-.613 12.775-7.116 20.707-11.54z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7BFF7B",
    d: "m18.088 17.165 5.262-5.383S3.822.935 2.644.295C2.199.03 1.7-.05 1.256.03z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#6ED8FF",
    d: "M18.088 17.165 1.256.03C.576.19 0 .802 0 2.055V32.38c0 1.146.445 1.972 1.283 2.052z"
  })));
};
export default SvgPlayStore;